<script setup lang="ts">
import {useLanguage} from '../composables/useLanguage';
import {company} from '../config/company';

const {isArabic} = useLanguage();
</script>

<template>
  <a class="brand" href="#home" aria-label="ALQASWA ALKOBRA home">
    <img class="brand__mark" src="/images/logo.png" alt="ALQASWA ALKOBRA" />
    <span class="brand__copy">
      <strong>{{ isArabic ? company.shortNameAr : company.nameEn }}</strong>
      <small>{{ isArabic ? 'للمقاولات العامة والاستثمار العقاري' : 'Contracting & Real Estate Investment' }}</small>
    </span>
  </a>
</template>
